<template>
  <a-spin :spinning="loading">
    <a-tabs default-active-key="1">
      <a-tab-pane key="1">
      <span slot="tab">
        <a-icon type="bank" />
        Información bancaria
      </span>
    <a-row :gutter="[16,16]">
      <a-form-model :model="iPersona" :rules="formRules" @submit="guardarInformacionBancaria"
                    @submit.native.prevent ref="datosPersonalesForm">
        <a-col :span="24">
          <a-card>
            <a-row :gutter="[16,16]">

              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('Banco')" prop="id_bank" has-feedback>
                  <form-model-dropdown style="width: 100%"
                                       endpoint="bank"
                                       v-model="iPersona.id_bank"
                                       :customSlots="['suffixIcon']"
                  >
                  </form-model-dropdown>
                </a-form-model-item>
              </a-col>

              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('Tipo de cuenta')" prop="account_type" has-feedback>
                  <form-model-dropdown style="width: 100%"
                                       endpoint="hierarchy_lookup"
                                       v-model="iPersona.account_type"
                                       :customSlots="['suffixIcon']"
                                       :params="request.tipo_cuenta"
                  >
                  </form-model-dropdown>
                </a-form-model-item>
              </a-col>

              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('Número de cuenta')" prop="account_number" has-feedback>
                  <a-input style="width: 100%"
                           class="ant-uppercase"
                           v-model="iPersona.account_number"></a-input>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-divider type="horizontal"/>
            <a-row style="text-align: right" :bodyStyle="{padding: '12px 24px'}">
              <a-button v-if="!$userIsInrol('Query')"
                type="primary"
                html-type="submit">
                Guardar datos personales
              </a-button>
            </a-row>
          </a-card>
        </a-col>
      </a-form-model>
    </a-row>
      </a-tab-pane>
      <a-tab-pane key="2">
      <span slot="tab">
        <a-icon type="bank" />
        Información bancaria internacional
      </span>
      <biodata-informacion-bancaria-internacional :persona="persona"></biodata-informacion-bancaria-internacional>
      </a-tab-pane>
    </a-tabs>
  </a-spin>
</template>
<script>
  import JsUtils from '@/util/JsUtils'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'
  import HttpUtil from '@/util/HttpUtil'

  export default {
    data () {
      return {
        request: {
          tipo_cuenta: {
            h_lookup_type: 'TIPO_CUENTA'
          }
        },
        dropdown: {
          country_expedition_selected: {}
        },
        iPersona: {},
        formRules: {},
        loading: false,
        colSpan: {
          xs: 24,
          md: 8
        }
      }
    },
    props: ['persona'],
    methods: {
      guardarInformacionBancaria () {
        if (this.loading) return
        this.$refs.datosPersonalesForm.validate(valid => {
          if (valid) {
            this.loading = true
            let request = {...this.iPersona, id_person: this.persona}

            this.httpClient.getInstance().post('biodata/guardar_person_colbank', request)
              .then(() => {
                Mensajes.success('Correcto', 'Datos guardados correctamente')
              })
              .catch(() => {
                Mensajes.error('Error', 'No fue posible guardar la información, contacte al administrador.')
              })
              .then(() => {
                this.loading = false
              })
          }
        })
      },
      loadData () {
        if (JsUtils.isEmpty(this.persona)) {
          return
        }
        this.loading = true
        this.httpClient.getInstance().get('biodata/consultar_person_colbank/' + this.persona)
          .then(response => {
            this.iPersona = {...response.data}
          })
          .catch(() => {
            Mensajes.error('Error', 'No fue posible consultar los datos personales, contacte al administrador.')
          })
          .then(() => {
            this.loading = false
          })
      },
      initFormRules () {
        this.formRules = {
          account_type: [{required: true, message: 'Valor requerido'}],
          id_bank: [{required: true, message: 'Valor requerido'}],
          account_number: [{required: true, message: 'Valor requerido'}]
        }
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
      this.loadData()
      this.initFormRules()
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Biodata/BiodataInformacionBancaria.vue